import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import CompanyScanAppShell from '../flows/src/components/ui/company-scan/components/app-shell/CompanyScanAppShell';
import CompanyScan from './pages';
import Welcome from './pages/intro';
import store, { persistor } from './store/redux/store';
import ErrorBoundary from '../app/src/components/ErrorBoundary';
import { PersistGate } from 'redux-persist/integration/react';
import { Center } from '@wegroup/design-system';
import LoadingSpinner from '../common/src/components/LoadingSpinner';
import LogRocket from 'logrocket';
import Lookup from './pages/lookup';
import useFeatureFlags from '../app/src/hooks/useFeatureFlags';
import DisabledModulePage from '../app/src/features/disabled-module-page/DisabledModulePage';
import SocialRoute from '../app/src/features/routing/components/SocialRoute';

const CompanyScanRouter: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const featureFlags = useFeatureFlags();

  useEffect(() => {
    LogRocket.track('CompanyScan');
  }, []);

  if (featureFlags.isCompanyScanDisabled) {
    return <DisabledModulePage pageName={t('COMPANY-SCAN')} />;
  }

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate
          loading={
            <Center height="100vh" w="100%">
              <LoadingSpinner />
            </Center>
          }
          persistor={persistor}
        >
          <Helmet>
            <title>{t('COMPANY-SCAN')} | WeGroup</title>
          </Helmet>

          <CompanyScanAppShell>
            <Switch>
              <Route path="/company-scan" component={CompanyScan} exact />
              <Route
                path="/company-scan/lookup"
                render={() => (
                  <SocialRoute>
                    <Lookup />
                  </SocialRoute>
                )}
                exact
              />
              <Route
                path="/company-scan/intro"
                render={() => (
                  <SocialRoute>
                    <Welcome />
                  </SocialRoute>
                )}
                exact
              />
            </Switch>
          </CompanyScanAppShell>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  );
};

export default CompanyScanRouter;
